import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiltersForm } from '../components/FiltersForm';
import { SvgBarChart } from '../components/SvgBarChart';
import { Table } from '../components/Table';
import { DownloadMenu } from '../components/DownloadMenu';
import { Section } from '../components/Section';
import { anomaliesSchema } from '../validation';
import { useKpiAnomalies, useQueryParams } from '../hooks/useKpi';
import type { AnomaliesParams } from '../types';

const defaults: AnomaliesParams = { collection: '', interval: 'day' };

export default function Anomalies() {
  const [search] = useSearchParams();
  const merged = useQueryParams(defaults, search) as any;
  const [params, setParams] = useState<AnomaliesParams | undefined>(merged.collection ? merged : undefined);
  const query = useKpiAnomalies(params);

  return (
    <Section title="Anomalías" description="Detecta comportamientos fuera de rango">
      <FiltersForm defaultValues={merged} schema={anomaliesSchema} fields={[{ name: 'collection', label: 'Colección' }, { name: 'interval', label: 'Intervalo', type: 'select', options: ['day', 'week', 'month'] }]} onSubmit={(values) => setParams(values)} />
      {query.isLoading && <p>Cargando...</p>}
      {query.error && <p className="text-red-600">Error al cargar</p>}
      {query.data && <div className="space-y-4"><SvgBarChart data={query.data.map((d) => ({ label: d.label, value: d.value }))} /><DownloadMenu filename="anomalies" rows={query.data as any} /><Table rows={query.data as any} /></div>}
    </Section>
  );
}
